import { RecordingSpeakerRoleType } from "@repo/app-types/entities/recording";
import { IconUser, IconUserBolt } from "@tabler/icons-react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export type TranscriptSpeakerAvatarProps = {
  speakerName: string;
} & (
  | {
      speakerRole: typeof RecordingSpeakerRoleType.Representative;
      isAgent: boolean;
    }
  | {
      speakerRole?:
        | typeof RecordingSpeakerRoleType.Customer
        | typeof RecordingSpeakerRoleType.Other
        | undefined;
      isAgent?: never;
    }
);

export const TranscriptSpeakerAvatar: FC<TranscriptSpeakerAvatarProps> = (
  props,
) => {
  const { speakerName, speakerRole, isAgent } = props;
  const words = speakerName.trim().split(/\s+/);
  const firstInitial = words[0]?.charAt(0) ?? "";
  const lastInitial = words.length > 1 ? (words.at(-1)?.charAt(0) ?? "") : "";
  const initials = `${firstInitial}${lastInitial}`.toLocaleUpperCase();

  return (
    <span
      aria-hidden="true"
      className={twMerge(
        "flex size-8 shrink-0 items-center justify-center rounded-md text-xs font-medium [box-shadow:none] select-none",
        speakerRole === RecordingSpeakerRoleType.Customer &&
          "bg-amber-50 text-amber-900 [box-shadow:var(--transcript-avatar-shadow,none)]",
        speakerRole === RecordingSpeakerRoleType.Representative &&
          (isAgent
            ? "bg-violet-50 text-violet-700 [box-shadow:var(--transcript-avatar-shadow,none)]"
            : "bg-blue-50 text-blue-800 [box-shadow:var(--transcript-avatar-shadow,none)]"),
        (speakerRole === undefined ||
          speakerRole === RecordingSpeakerRoleType.Other) &&
          "bg-gray-100 text-gray-600",
      )}
    >
      {isAgent ? (
        <IconUserBolt className="size-4" />
      ) : speakerName === "Unknown speaker" || !initials ? (
        <IconUser className="size-4" />
      ) : (
        initials
      )}
    </span>
  );
};
